import SearchBar from '@components/lib/searchbar/searchbar';
import { colors, weights } from '@components/theme/styles/index';
import { Button, Dialog, ListItemButton, styled } from '@mui/material';
import { rem } from 'polished';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    width: '100%',
    maxWidth: rem(550),
    margin: 0,
  },
});

export const StyledDisabledListItemButton = styled(ListItemButton)({
  color: `${colors.grayDark3} !important`,
  opacity: `1 !important`,
});

export const StyledFinderLabel = styled('p')({
  display: 'flex',
  marginBottom: rem(10),

  '& > span': {
    fontWeight: weights.semiBold,
    marginLeft: rem(5),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
});

export const StyledFinderSearchBar = styled(SearchBar)({
  marginBottom: rem(10),
});

export const StyledNewFolderButton = styled(Button)({
  marginTop: rem(20),
});

export const StyledFinderFooter = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});
